(() => {
  const updateShade = () => {
    const detail = document.querySelector('[data-aw-pdp-detail]');
    const main = document.querySelector('.aw-pdp-main');
    if (!detail || !main) return;
    const id = main.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
    if (!id) return;
    detail.querySelectorAll('[data-aw-pdp-variant]').forEach(panel => {
      panel.hidden = panel.dataset.awPdpVariant !== id;
    });
  };
  document.addEventListener('change', event => {
    if (event.target.matches('.aw-pdp-main form[action*="/cart/add"] input[name="id"]')) updateShade();
  });
  document.addEventListener('shopify:section:load', updateShade);
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-aw-pdp-zoom]');
    const dialog = document.querySelector('[data-aw-pdp-zoomdialog]');
    if (!dialog) return;
    if (trigger) {
      const source = trigger.querySelector('img') || document.getElementById(trigger.dataset.awPdpZoomTarget);
      if (!source) return;
      const expanded = dialog.querySelector('[data-aw-pdp-zoomimage]');
      expanded.src = source.currentSrc || source.src;
      expanded.alt = source.alt;
      expanded.width = source.naturalWidth || source.width;
      expanded.height = source.naturalHeight || source.height;
      dialog.addEventListener('close', () => trigger.focus(), {once: true});
      dialog.showModal();
      dialog.scrollTop = 0;
      dialog.scrollLeft = 0;
    } else if (event.target.closest('[data-aw-pdp-zoomclose]') || event.target === dialog) {
      dialog.close();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateShade); else updateShade();
})();
